import * as React from 'react'

import { observer } from 'mobx-react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'
import { dateToString } from 'modules/core/lib/dates'

import type FaceRecognitionLogsForm from 'modules/employees/components/FaceRecognition/Logs/Layout/form'
import { ClockPictures } from 'modules/employees/store/collections/clockPictures'

import ClockPicturesTable from './Table'

interface Props {
  employeeId: string
  employeeFullName: string
  logsForm: FaceRecognitionLogsForm
}

const Content = ({ employeeId, employeeFullName, logsForm }: Props) => {
  const clockPictures = React.useRef(new ClockPictures()).current
  useUnsafeAsyncData(() => {
    return clockPictures.fetch({
      data: {
        employee_ids: [employeeId],
        start_on: dateToString(logsForm.startOn, 'backend'),
        end_on: dateToString(logsForm.endOn, 'backend'),
      },
    })
  }, [employeeId, logsForm.date.month()])

  return (
    <ClockPicturesTable
      clockPictures={clockPictures.toArray()}
      employeeFullName={employeeFullName}
    />
  )
}

export default observer(Content)
